export const Calendar = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8828 4.17188H4.50781C4.11085 4.17188 3.78906 4.49367 3.78906 4.89062V19.2656C3.78906 19.6626 4.11085 19.9844 4.50781 19.9844H18.8828C19.2798 19.9844 19.6016 19.6626 19.6016 19.2656V4.89062C19.6016 4.49367 19.2798 4.17188 18.8828 4.17188Z"
      stroke="currentColor"
      strokeWidth="1.67273"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0078 2.73438V5.60937"
      stroke="currentColor"
      strokeWidth="1.67273"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.38281 2.73438V5.60937"
      stroke="currentColor"
      strokeWidth="1.67273"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.78906 8.48438H19.6016"
      stroke="currentColor"
      strokeWidth="1.67273"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9297 12.0781L10.734 16.0312L8.46094 13.8751"
      stroke="currentColor"
      strokeWidth="1.67273"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
